import { render, staticRenderFns } from "./modalCrearDirecciones.vue?vue&type=template&id=04c646e4"
import script from "./modalCrearDirecciones.vue?vue&type=script&lang=js"
export * from "./modalCrearDirecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports